import React  from 'react';
import TabContainer from '../../../../../common/components/tab/containers/tab.containers';
import { useSelector } from 'react-redux';
import { selectListItems } from '../../../../../redux/library/selector';
import MediaInfoComponent from '../../../../../common/components/common/media-info.component';
import EndpointBasicInfoComponent from './endpoint-basic-info.component';


export const EndpointComponent = ({mediaFiles,handleFormItemChange,changeImage,handleInnerFormChange,selectedEndpoint,back,handleFormSubmit}: any) => {
  const libraryData = useSelector(selectListItems)
  const tabItems=[
    {
        id:1,
        title:'Basic Information',
        component:<EndpointBasicInfoComponent 
        handleInnerFormChange={handleInnerFormChange}
        selectedEndpoint={selectedEndpoint}
        />,
    isVisible:true,
    },
    {
      id:2,
      title:'Media',
      component:<MediaInfoComponent
      changeImage={changeImage}
      fileTypes={libraryData?.result?.FileType}
      onFormItemChange={handleFormItemChange}
      mediaFiles={mediaFiles}
      />,
  isVisible:true,
  },
    
  ]
    
  return (
    <div className="flex flex-col items-center w-full px-5 h-[620px] overflow-auto">
       
     
      <TabContainer tabItems={tabItems} />
   
      <div className='flex w-full justify-end items-end'>
        <button
              onClick={back}
              type='button'
              className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
             >
              Back
             </button>
             <button
            className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
              onClick={handleFormSubmit}
            
              type="submit"
          >
            Save
          </button>
        </div>
       </div>
  )
}
export default EndpointComponent;
